import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import NoSearchResult from './NoSearchResult';
import NoEntry from './TitleMessagePage';
import { Add as AddIcon } from '@material-ui/icons';
import { Fab } from '@material-ui/core';

interface Props {
  title?: string,
  message?: string,
  searchText?: string,
  displayFab: boolean,
  onFabClicked?: () => void
}

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 4,
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
});


type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class EmptyPage extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    return (
      <>
        {this.props.searchText ?
          <NoSearchResult searchText={this.props.searchText}/> :
          <NoEntry title={this.props.title} message={this.props.message}/>
        }
        <>
          {this.props.displayFab &&
          <Fab color="primary" arial-label="Add" className={this.props.classes.button}
               onClick={this.props.onFabClicked}>
            <AddIcon/>
          </Fab>
          }

        </>
      </>
    );
  }
}

export default withStyles(localStyles)(EmptyPage);
